import { useMemo } from "react";

import { useCurrentTimezone } from "@/common/hooks";

import { ShiftEditorTimePickers } from "../TimePickers";
import { TShiftEditorProps } from "../types";

export const TimePickers = (props: TShiftEditorProps) => {
  const {
    staffShift,
    updateStaffShift,
    unitOfShift,
    readonly,
    availableShiftTypes,
    setShiftsValidity,
  } = props;
  // use timezone of unit of shift, NOT facility timezone
  const timezone = useCurrentTimezone(unitOfShift.id);

  const shiftType = useMemo(
    () =>
      staffShift.shiftTypeKey &&
      availableShiftTypes?.find(({ key }) => key === staffShift.shiftTypeKey),
    [availableShiftTypes, staffShift.shiftTypeKey],
  );

  return (
    <ShiftEditorTimePickers
      size="small"
      timezone={timezone}
      staffShift={staffShift}
      updateStaffShift={updateStaffShift}
      shiftType={shiftType}
      readonly={readonly}
      setShiftValidity={(isValid) =>
        setShiftsValidity((prev) => ({ ...prev, [staffShift.id]: isValid }))
      }
    />
  );
};
